// These go to the API verbatim and are matched CASE-SENSITIVELY server-side, so
// they must all stay lowercase. `OPENING_STOCK` was "OP" and every save failed
// validation with `vtype must be dm or op` — proven against the live validator,
// which accepts "op" and "dm" ("dm" being the damage-entry counterpart) and
// rejects "OP".
export const VTYPE = {
  OPENING_STOCK: "op",
  // Damage rides the same `stock-entry` API as opening stock — the ONLY difference in the
  // payload is this value. The validator accepts exactly "op" and "dm".
  DAMAGE: "dm",
  PURCHASE: "pr",
  PURCHASE_RETURN: "rr",
  SALE: "st",
  POS: "ps",
};

export const ITYPE = {
  STOCK: "s",
};

export const CASHCREDIT_OPTIONS = [
  { value: "c",  label: "Cash"   },
  { value: "r", label: "Credit" },
];

export const UPEXUP_OPTIONS = [
  { value: "u", label: "up" },
  { value: "x", label: "Ex-Up"  },
];

// Same "u"/"x" values under plain-English wording, used on the Purchase Entry
// screens. Derived from UPEXUP_OPTIONS so the two lists can never drift apart:
// only the visible label differs — the value still drives the CGST/SGST-vs-IGST
// split via `isUP`, so it must never be renamed.
export const LOCAL_INTERSTATE_OPTIONS = UPEXUP_OPTIONS.map((o) => ({
  value: o.value,
  label: o.value === "u" ? "Local" : "Interstate",
}));

export const ISCASH_OPTIONS = [
  { value: "false", label: "Credit" },
  { value: "true",  label: "Cash"   },
];
